<ion-row class="sidebar" *ngIf="!display || display === 'sidebar'">
  <ion-col size="12">
    <p class="sidebar-title">Related Blogs</p>
  </ion-col>
  <ion-col size="12" size-sm="6" size-lg="12" class="hover" *ngFor="let blog of blogs" style="margin-top: 40px;">
    <a routerDirection="root" [routerLink]="'/blog/' + blog.shortid">
      <span class="hoverover" *ngIf="blog.media.list && blog.media.list[0] && blog.media.list[0].url">
        <img id="blogthumbnail" [src]="blog.media.list[0].url" [alt]="blog.metaimagealt ? blog.metaimagealt : blog.title" loading="lazy">
      </span>
      <p id="title">{{blog.h1}}</p>
    </a>
  </ion-col>
</ion-row>

<ion-row class="horizontal" *ngIf="display === 'horizontal'">
  <ion-slides pager="true" loop="true" [options]="relatedblogsSliderOptions" id="relatedblogsSlider" #relatedblogsSlider>
    <ion-slide *ngFor="let blog of blogs" style="align-items: flex-start;">
      <ion-row>
        <ion-col size="12" class="ion-padding-horizontal ion-text-left">
          <a routerDirection="root" [routerLink]="'/blog/' + blog.shortid">
            <span class="hoverover" *ngIf="blog.media.list && blog.media.list[0] && blog.media.list[0].url">
              <img id="blogthumbnail" [src]="blog.media.list[0].url" [alt]="blog.metaimagealt ? blog.metaimagealt : blog.title" loading="lazy">
            </span>
            <p id="title">{{blog.h1}}</p>
          </a>
        </ion-col>
      </ion-row>
    </ion-slide>
  </ion-slides>
  <ion-col size="12" class="nucamp-swiper-navigation ion-no-padding">
    <ion-row class="ion-no-padding">
      <ion-col size="3.5" size-sm="4.5" (click)="swipePrevBlog()"
        class="ion-text-right nucamp-swiper-button-prev ion-no-padding">
        <fa-icon [icon]="faAngleDoubleLeft"></fa-icon>
      </ion-col>
      <ion-col size="5" size-sm="3"></ion-col>
      <ion-col size="3.5" size-sm="4.5" (click)="swipeNextBlog()"
        class="ion-text-left nucamp-swiper-button-next ion-no-padding">
        <fa-icon [icon]="faAngleDoubleRight"></fa-icon>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>